
import pageTransition from '@/mixins/pageTransition'

export default {
  props: {
    page: Object
  },
  mixins: [pageTransition]
}
